export const API_URL = process.env.REACT_APP_API;
export const SNAP_URL = process.env.REACT_APP_SNAP;